module.exports = __webpack_public_path__ + "static/img/mobile-3.c58b4d77.png";